import React, { lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import LoadingScreen from '../features/shared/LoadingScreen';
import HomePage from '../features/home/HomePage';
import ArticlePage from '../features/articles/ArticlePage';
import ArticleListPage from '../features/articles/ArticleListPage';
import AboutPage from '../features/about/AboutPage';
import OfflinePage from '../features/shared/OfflinePage';

const NotFoundPage = lazy(() => import('../features/shared/NotFoundPage'));

function AppRouter() {
  return (
    <Routes>
      {/* 主頁 */}
      <Route path="/" element={<HomePage />} />

      {/* 文章列表頁 */}
      <Route path="/articles" element={<ArticleListPage />} />

      {/* 關於本站 */}
      <Route path="/about" element={<AboutPage />} />

      {/* 離線頁面 */}
      <Route path="/offline" element={<OfflinePage />} />

      {/* 🔥 動態文章路由 - 使用單一路由處理所有文章 */}
      <Route path="/:slug" element={<ArticlePage />} />

      {/* 404 頁面 */}
      <Route
        path="/404"
        element={
          <Suspense fallback={<LoadingScreen />}>
            <NotFoundPage />
          </Suspense>
        }
      />

      {/* 捕捉所有未匹配的路徑 */}
      <Route
        path="*"
        element={
          <Suspense fallback={<LoadingScreen />}>
            <NotFoundPage />
          </Suspense>
        }
      />
    </Routes>
  );
}

export default AppRouter;